import React, { PropTypes } from 'react';
import { parseLatLng } from '../../businessLogic/util';

export default class LatLngInput extends React.Component {

	constructor(props) {
		super(props);
		this.state = { animate: false };
	}

	render () {	
		const { label, value, index, action, validation, helpText, disabled } = this.props;
		return (						
			<div className='form-group'>
				<label>{label}</label>
				<input 
					type="text"
					placeholder='Obrigatório'
					disabled={disabled}
					value={parseLatLng(value)}
					className="form-control"
					onChange={(e) => {
						const onSuccess = (value) => {
							clearTimeout(this.timeout);
							this.setState({animate: false});
							action(value, index);
						};
						const onError = () => {
							clearTimeout(this.timeout);
							this.setState({animate: true});
							this.timeout = setTimeout(() => this.setState({animate: false}), 2000);
						};
						return validation(e.target.value, onSuccess, onError);								
					}} 
				/>
				<small>{helpText}</small>
			</div>				
		);
	}
}

LatLngInput.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	validation: PropTypes.func.isRequired,
	action: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	helpText: PropTypes.string.isRequired
};

LatLngInput.defaultProps = {
	disabled: false
};


// WEBPACK FOOTER //
// ./src/components/Common/LatLngInput.js